import { DONATION_BNB_TOAST_ITEMS } from '@/app/donation/constants';

const FLOATING_BNB_DONATION_PATHS = new Set<string>([
  ...DONATION_BNB_TOAST_ITEMS.map(({ route }) => route.pathname),
]);

export type FloatingBnbKind = 'donation';

export const getFloatingBnbKind = (
  pathname: string | null | undefined,
): FloatingBnbKind | null => {
  if (!pathname) return null;
  if (FLOATING_BNB_DONATION_PATHS.has(pathname)) return 'donation';

  return null;
};
